import Layout from 'components/Layout/Layout'
import React from 'react'
import { connect } from 'react-redux'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import 'semantic-ui-css/semantic.min.css'
import "@blueprintjs/core/lib/css/blueprint.css";

import Success from 'routes/Success'
import Landing from 'routes/Landing'


export const rootPath = ''
export const landingPath = `${rootPath}/`
export const SuccessPath = (id) => `${rootPath}/Success/${id}`

const ApplicationRoute = (props) => {

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path={landingPath} element={<Landing />} key='Landing' />
          <Route path={SuccessPath(':id')} element={<Success />} key='Success' />
        </Routes>
      </Layout>
    </Router>
  )
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationRoute)